import axios from "axios";
import { message } from "antd";

const apiUrl = process.env.REACT_APP_API_URL;

export const get_app_data = async (token) => {
	try {
		const res = await axios.post(`${apiUrl}/app_data`, {token});
		if (res.status === 200) return res.data;		
		message.success(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};